<template>
  <section class="sm-customers-top">
    <div 
      v-if="provider.client_level"
      class="sm-customers-top-inner"
    >
      <div class="sm-customers__top-flex">
        <div class="sm-customers__top-row">
          <div class="sm-customers__top-title">
            <a
              href="#" 
              @click.prevent="$router.push('customers')"
            >
              <include-svg :name="'icon-customers-sec'" />
            </a>
            <h2>{{provider.client_level != 1 ? 'Customers' : 'Users'}}</h2>
          </div>
          <tabs-elem
            :tabs="tabs"
          />
        </div>
        <div class="sm-customers__top-controls">
          <input-search
            v-if="customersList.length || $route.query.search"
            v-model="search"
            :defaultVal="searchStartVal"
            @submit="sendSearchReq"
            @input="checkInput"
          />

          <template v-if="user.privileged_user">
            <btn-block
              :type="'grey-cut'"
              :text="'Import Users (.csv)'"
              :icon="'icon-download2'"
              @click="popup.isOpen = true"
            />
          </template>

          <btn-block
            v-if="customersList.length && customersTotal"
            :type="'grey-cut'"
            :text="`Export ${customersTotal} User${customersTotal > 1 ? 's' : ''}`"
            :icon="'icon-upload'"
            @click="$emit('action', 'export')"
          />
          <btn-block
            :type="'small'"
            :text="'Add User'" 
            :icon="'icon-plus'"
            @click="$emit('action', 'new')"
          />
        </div>
      </div>
    </div>

    <popup-block
      v-if="popup.isOpen"
      :open="popup.isOpen"
      :size="'large-600'"
      @close="popup.isOpen = false;"
    >
      <template slot="popupContent">
        <import-customers
          @upload="handleImport"
        />
      </template>
    </popup-block>
  </section>
</template>

<script>
import Tabs from '@/components/Tabs';
import InputSearch from '@/components/InputSearch';
import { mapGetters } from 'vuex';
import Popup from '@/components/Popup';
import ImportCustomers from '@/views/admin/pages/customers/components/Import';

export default {
  name: 'customers-top',
  components: {
    'tabs-elem': Tabs,
    'input-search': InputSearch,
    'popup-block': Popup,
    'import-customers': ImportCustomers
  },
  data() {
    return {
      tabs: [
      {
        tab: 'active',
        text: 'Active'
      },
      {
        tab: 'inactive',
        text: 'Inactive'
      },
      {
        tab: 'all',
        text: 'All'
      }],
      search: '',
      searchStartVal: '',
      searchTimer: 0,
      searchTimerUpdate: 100,
      seachWait: 1000,
      popup: {
        isOpen: false
      }
    };
  },
  computed: {
    ...mapGetters({
      customersList: 'customers/customersList',
      customersTotal: 'customers/customersTotal',
      user: 'auth/user',
      provider: 'provider'
    })
  },
  created() {
    this.searchTimer = setInterval(() => this.searchTimer += this.searchTimerUpdate, this.searchTimerUpdate);
  },
  methods: {
    clearQueryParams(paramArr) {
      let query = Object.assign({}, this.$route.query);
      paramArr.forEach(param => delete query[param]);

      this.$router.push({query});
    },
    checkInput() {
      if (this.search.length < 2) {
        if (!this.search.length)
          this.clearQueryParams(['search']);
          
        return;
      }

      setTimeout(() => {
        if (this.searchTimer > this.seachWait) {
          this.sendSearchReq();
          this.searchTimer = 0;
        }
      }, this.seachWait);
    },
    sendSearchReq() {
      this.$router.push({
        query: {
          ...this.$route.query,
          ...{
            search: this.search
          }
        }
      });
    },
    handleImport($event) {
      this.popup.isOpen = false;
      this.$emit('upload', $event);
    }
  }
}
</script>
